const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

/**
 * The country codes are taken from: https://en.wikipedia.org/wiki/ISO_3166-1
 */
var countries = {
    'AF': {
        'name_en': 'Afghanistan',
        'name_fr': 'Afghanistan',
        'name_es': 'Afganistán',
        'flag': '122-afghanistan.png',
        'dialCode': '+93'
    },
    'AX': {
        'name_en': 'Åland Islands',
        'name_fr': 'Åland',
        'name_es': 'Åland',
        'flag': '105-aland-islands.png',
        'dialCode': '+358'
    },
    'AL': {
        'name_en': 'Albania',
        'name_fr': 'Albanie',
        'name_es': 'Albania',
        'flag': '117-albania.png',
        'dialCode': '+355'
    },
    'DZ': {
        'name_en': 'Algeria',
        'name_fr': 'Algérie',
        'name_es': 'Argel',
        'flag': '126-algeria.png',
        'dialCode': '+213'
    },
    'AS': {
        'name_en': 'American Samoa',
        'name_fr': 'Samoa américaines',
        'name_es': 'Samoa Americana',
        'flag': '085-american-samoa.png',
        'dialCode': '+1'
    },
    'AD': {
        'name_en': 'Andorra',
        'name_fr': 'Andorra',
        'name_es': 'Andorra',
        'flag': '102-andorra.png',
        'dialCode': '+376'
    },
    'AO': {
        'name_en': 'Angola',
        'name_fr': 'Angola',
        'name_es': 'Angola',
        'flag': '124-angola.png',
        'dialCode': '+244'
    },
    'AI': {
        'name_en': 'Anguilla',
        'name_fr': 'Anguilla',
        'name_es': 'Anguila',
        'flag': '087-anguilla.png',
        'dialCode': '+1'
    },
    'AG': {
        'name_en': 'Antigua and Barbuda',
        'name_fr': 'Antigua-et-Barbuda',
        'name_es': 'Antigua y Barbuda',
        'flag': '104-antigua-and-barbuda.png',
        'dialCode': '+1'
    },
    'AR': {
        'name_en': 'Argentina',
        'name_fr': 'Argentine',
        'name_es': 'Argentina',
        'flag': '064-argentina.png',
        'dialCode': '+54'
    },
    'AM': {
        'name_en': 'Armenia',
        'name_fr': 'Arménie',
        'name_es': 'Armenia',
        'flag': '121-armenia.png',
        'dialCode': '+374'
    },
    'AW': {
        'name_en': 'Aruba',
        'name_fr': 'Aruba',
        'name_es': 'Aruba',
        'flag': '099-aruba.png',
        'dialCode': '+297'
    },
    'AU': {
        'name_en': 'Australia',
        'name_fr': 'Australie',
        'name_es': 'Australia',
        'flag': '130-australia.png',
        'dialCode': '+61'
    },
    'AT': {
        'name_en': 'Austria',
        'name_fr': 'Autriche',
        'name_es': 'Austria',
        'flag': '189-austria.png',
        'dialCode': '+43'
    },
    'AZ': {
        'name_en': 'Azerbaijan',
        'name_fr': 'Azerbaïdjan',
        'name_es': 'Azerbaiyán',
        'flag': '125-azerbaijan.png',
        'dialCode': '+994'
    },
    'BH': {
        'name_en': 'Bahrain',
        'name_fr': 'Bahreïn',
        'name_es': 'Baréin',
        'flag': '116-bahrain.png',
        'dialCode': '+973'
    },
    'BD': {
        'name_en': 'Bangladesh',
        'name_fr': 'Bangladesh',
        'name_es': 'Bangladés',
        'flag': '128-bangladesh.png',
        'dialCode': '+880'
    },
    'BB': {
        'name_en': 'Barbados',
        'name_fr': 'Barbade',
        'name_es': 'Barbados',
        'flag': '111-barbados.png',
        'dialCode': '+1'
    },
    'BY': {
        'name_en': 'Belarus',
        'name_fr': 'Biélorussie',
        'name_es': 'Bielorrusia',
        'flag': '110-belarus.png',
        'dialCode': '+375'
    },
    'BE': {
        'name_en': 'Belgium',
        'name_fr': 'Belgique',
        'name_es': 'Bélgica',
        'flag': '054-belgium.png',
        'dialCode': '+32'
    },
    'BZ': {
        'name_en': 'Belize',
        'name_fr': 'Bélize',
        'name_es': 'Belice',
        'flag': '115-belize.png',
        'dialCode': '+501'
    },
    'BJ': {
        'name_en': 'Benin',
        'name_fr': 'Bénin',
        'name_es': 'Benín',
        'flag': '098-benin.png',
        'dialCode': '+229'
    },
    'BM': {
        'name_en': 'Bermuda',
        'name_fr': 'Bermudes',
        'name_es': 'Bermudas',
        'flag': '114-bermuda.png',
        'dialCode': '+1'
    },
    'BT': {
        'name_en': 'Bhutan',
        'name_fr': 'Bhoutan',
        'name_es': 'Bután',
        'flag': '094-bhutan.png',
        'dialCode': '+975'
    },
    'BO': {
        'name_en': 'Bolivia',
        'name_fr': 'Bolivie',
        'name_es': 'Bolivia',
        'flag': '133-bolivia.png',
        'dialCode': '+591'
    },
    'BA': {
        'name_en': 'Bosnia',
        'name_fr': 'Bosnie',
        'name_es': 'Bosnia',
        'flag': '113-bosnia-and-herzegovina.png',
        'dialCode': '+387'
    },
    'BW': {
        'name_en': 'Botswana',
        'name_fr': 'Botswana',
        'name_es': 'Botsuana',
        'flag': '127-botswana.png',
        'dialCode': '+267'
    },
    'BR': {
        'name_en': 'Brazil',
        'name_fr': 'Brésil',
        'name_es': 'Brazil',
        'flag': '250-brazil.png',
        'dialCode': '+55'
    },
    'IO': {
        'name_en': 'British Indian Ocean Territory',
        'name_fr': 'Territoire britannique de l\'océan Indien\n',
        'name_es': 'Territorio Británico del Océano Índico',
        'flag': '093-british-indian-ocean-territory.png',
        'dialCode': '+246'
    },
    'BN': {
        'name_en': 'Brunei',
        'name_fr': 'Brunei',
        'name_es': 'Brunéi',
        'flag': '107-brunei.png',
        'dialCode': '+673'
    },
    'BG': {
        'name_en': 'Bulgaria',
        'name_fr': 'Bulgarie',
        'name_es': 'Bulgaria',
        'flag': '135-bulgaria.png',
        'dialCode': '+359'
    },
    'BF': {
        'name_en': 'Burkina Faso',
        'name_fr': 'Burkina Faso',
        'name_es': 'Burkina Faso',
        'flag': '118-burkina-faso.png',
        'dialCode': '+226'
    },
    'BI': {
        'name_en': 'Burundi',
        'name_fr': 'Burundi',
        'name_es': 'Burundi',
        'flag': '103-burundi.png',
        'dialCode': '+257'
    },
    'KH': {
        'name_en': 'Cambodia',
        'name_fr': 'Cambodge',
        'name_es': 'Camboya',
        'flag': '132-cambodia.png',
        'dialCode': '+855'
    },
    'CM': {
        'name_en': 'Cameroon',
        'name_fr': 'Cameroon',
        'name_es': 'Camerún',
        'flag': '106-cameroon.png',
        'dialCode': '+237'
    },
    'CA': {
        'name_en': 'Canada',
        'name_fr': 'Canada',
        'name_es': 'Canadá',
        'flag': '206-canada.png',
        'dialCode': '+1'
    },
    'CV': {
        'name_en': 'Cabo Verde',
        'name_fr': 'Cap-Vert',
        'name_es': 'Cabo Verde',
        'flag': '096-cape-verde.png',
        'dialCode': '+238'
    },
    'BQ': {
        'name_en': 'Bonaire',
        'name_fr': 'Bonaire',
        'name_es': 'Bonaire',
        'flag': '109-bonaire.png',
        'dialCode': '+599'
    },
    'KY': {
        'name_en': 'Cayman Islands',
        'name_fr': 'Îles Caïmans',
        'name_es': 'Islas Caimán',
        'flag': '092-cayman-islands.png',
        'dialCode': '+1'
    },
    'CF': {
        'name_en': 'Central African Republic',
        'name_fr': 'République centrafricaine',
        'name_es': 'República Centroafricana',
        'flag': '091-central-african-republic.png',
        'dialCode': '+236'
    },
    'TD': {
        'name_en': 'Chad',
        'name_fr': 'Tchad',
        'name_es': 'Chad',
        'flag': '095-chad.png',
        'dialCode': '+235'
    },
    'CL': {
        'name_en': 'Chile',
        'name_fr': 'Chilie',
        'name_es': 'Chile',
        'flag': '051-chile.png',
        'dialCode': '+56'
    },
    'CN': {
        'name_en': 'China',
        'name_fr': 'Chine',
        'name_es': 'China',
        'flag': '261-china.png',
        'dialCode': '+86'
    },
    'CX': {
        'name_en': 'Christmas Island',
        'name_fr': 'Kiritimati',
        'name_es': 'Kiritimati',
        'flag': '083-christmas-island.png',
        'dialCode': '+61'
    },
    'CC': {
        'name_en': 'Cocos Islands',
        'name_fr': 'Îles Cocos',
        'name_es': 'Islas Cocos',
        'flag': '082-cocos-island.png',
        'dialCode': '+61'
    },
    'MF': {
        'name_en': 'Saint-Martin',
        'name_fr': 'Saint-Martin',
        'name_es': 'Saint-Martin',
        'flag': '077-france.png',
        'dialCode': '+590'
    },
    'CO': {
        'name_en': 'Colombia',
        'name_fr': 'Colombie',
        'name_es': 'Colombia',
        'flag': '062-colombia.png',
        'dialCode': '+57'
    },
    'KM': {
        'name_en': 'Comoros',
        'name_fr': 'Comores',
        'name_es': 'Comoras',
        'flag': '090-comoros.png',
        'dialCode': '+269'
    },
    'CK': {
        'name_en': 'Cook Islands',
        'name_fr': 'Îles Cook',
        'name_es': 'Islas Cook',
        'flag': '081-cook-islands.png',
        'dialCode': '+682'
    },
    'CR': {
        'name_en': 'Costa Rica',
        'name_fr': 'Costa Rica',
        'name_es': 'Costa Rica',
        'flag': '131-costa-rica.png',
        'dialCode': '+506'
    },
    'HR': {
        'name_en': 'Croatia',
        'name_fr': 'Croatie',
        'name_es': 'Croacia',
        'flag': '134-croatia.png',
        'dialCode': '+385'
    },
    'CU': {
        'name_en': 'Cuba',
        'name_fr': 'Cuba',
        'name_es': 'Cuba',
        'flag': '129-cuba.png',
        'dialCode': '+53'
    },
    'CW': {
        'name_en': 'Curaçao',
        'name_fr': 'Curaçao',
        'name_es': 'Curazao',
        'flag': '212-curacao.png',
        'dialCode': '+599'
    },
    'CY': {
        'name_en': 'Cyprus',
        'name_fr': 'Chypre',
        'name_es': 'Chipre',
        'flag': '030-cyprus.png',
        'dialCode': '+357'
    },
    'CZ': {
        'name_en': 'Czech Republic',
        'name_fr': 'République Czech',
        'name_es': 'República Checa',
        'flag': '061-czech-republic.png',
        'dialCode': '+420'
    },
    'CG': {
        'name_en': 'Republic of the Congo',
        'name_fr': 'République du Congo',
        'name_es': 'República del Congo',
        'flag': '240-republic-of-the-congo.png',
        'dialCode': '+242'
    },
    'CD': {
        'name_en': 'Democratic Republic of the Congo',
        'name_fr': 'République démocratique du Congo',
        'name_es': 'República Democrática del Congo',
        'flag': '240-democratic-republic-of-the-congo.png',
        'dialCode': '+243'
    },
    'DK': {
        'name_en': 'Denmark',
        'name_fr': 'Danemark',
        'name_es': 'Dinamarca',
        'flag': '072-denmark.png',
        'dialCode': '+45'
    },
    'DJ': {
        'name_en': 'Djibouti',
        'name_fr': 'Djibouti',
        'name_es': 'Yibuti',
        'flag': '211-djibouti.png',
        'dialCode': '+253'
    },
    'DM': {
        'name_en': 'Dominica',
        'name_fr': 'Dominique',
        'name_es': 'Dominica',
        'flag': '147-dominica.png',
        'dialCode': '+1'
    },
    'DO': {
        'name_en': 'Dominican Republic',
        'name_fr': 'République Dominicaine',
        'name_es': 'República Dominicana',
        'flag': '018-dominican-republic.png',
        'dialCode': '+1'
    },
    'TL': {
        'name_en': 'Timor-Leste',
        'name_fr': 'Timor oriental',
        'name_es': 'Timor Oriental',
        'flag': '226-east-timor.png',
        'dialCode': '+670'
    },
    'EC': {
        'name_en': 'Ecuador',
        'name_fr': 'Équateur',
        'name_es': 'Ecuador',
        'flag': '049-ecuador.png',
        'dialCode': '+593'
    },
    'EG': {
        'name_en': 'Egypt',
        'name_fr': 'Égypte',
        'name_es': 'Egipto',
        'flag': '079-egypt.png',
        'dialCode': '+20'
    },
    'SV': {
        'name_en': 'El Salvador',
        'name_fr': 'Salvador',
        'name_es': 'El Salvador',
        'flag': '015-el-salvador.png',
        'dialCode': '+503'
    },
    'GQ': {
        'name_en': 'Equatorial Guinea',
        'name_fr': 'Guinée équatoriale',
        'name_es': 'Guinea Ecuatorial',
        'flag': '241-equatorial-guinea.png',
        'dialCode': '+240'
    },
    'ER': {
        'name_en': 'Eritrea',
        'name_fr': 'Érythrée',
        'name_es': 'Eritrea',
        'flag': '210-eritrea.png',
        'dialCode': '+291'
    },
    'EE': {
        'name_en': 'Estonia',
        'name_fr': 'Estonie',
        'name_es': 'Estonia',
        'flag': '257-estonia.png',
        'dialCode': '+372'
    },
    'ET': {
        'name_en': 'Ethiopia',
        'name_fr': 'Éthiopie',
        'name_es': 'Etiopía',
        'flag': '001-ethiopia.png',
        'dialCode': '+251'
    },
    'FK': {
        'name_en': 'Falkland Islands',
        'name_fr': 'Îles Malouines',
        'name_es': 'Islas Malvinas',
        'flag': '187-falkland-islands.png',
        'dialCode': '+500'
    },
    'FO': {
        'name_en': 'Faroe Islands',
        'name_fr': 'Îles Féroé',
        'name_es': 'Islas Faroe',
        'flag': '146-faroe-islands.png',
        'dialCode': '+298'
    },
    'FJ': {
        'name_en': 'Fiji',
        'name_fr': 'Fidji',
        'name_es': 'Fiyi',
        'flag': '145-fiji.png',
        'dialCode': '+679'
    },
    'FI': {
        'name_en': 'Finland',
        'name_fr': 'Finlande',
        'name_es': 'Finlandia',
        'flag': '052-finland.png',
        'dialCode': '+358'
    },
    'FR': {
        'name_en': 'France',
        'name_fr': 'France',
        'name_es': 'France',
        'flag': '077-france.png',
        'dialCode': '+33'
    },
    'GF': {
        'name_en': 'French Guiana',
        'name_fr': 'Guyane',
        'name_es': 'Guayana Francesa',
        'flag': '077-france.png',
        'dialCode': '+594'
    },
    'PF': {
        'name_en': 'French Polynesia',
        'name_fr': 'Polynésie française',
        'name_es': 'Polinesia Francesa',
        'flag': '234-french-polynesia.png',
        'dialCode': '+689'
    },
    'GA': {
        'name_en': 'Gabon',
        'name_fr': 'Gabon',
        'name_es': 'Gabón',
        'flag': '186-gabon.png',
        'dialCode': '+241'
    },
    'GM': {
        'name_en': 'Gambia',
        'name_fr': 'Gambie',
        'name_es': 'Gambia',
        'flag': '159-gambia.png',
        'dialCode': '+220'
    },
    'GE': {
        'name_en': 'Georgia',
        'name_fr': 'Géorgie',
        'name_es': 'Georgia',
        'flag': '256-georgia.png',
        'dialCode': '+995'
    },
    'DE': {
        'name_en': 'Germany',
        'name_fr': 'Allemagne',
        'name_es': 'Alemania',
        'flag': '066-germany.png',
        'dialCode': '+49'
    },
    'GH': {
        'name_en': 'Ghana',
        'name_fr': 'Ghana',
        'name_es': 'Ghana',
        'flag': '255-ghana.png',
        'dialCode': '+233'
    },
    'GI': {
        'name_en': 'Gibraltar',
        'name_fr': 'Gibraltar',
        'name_es': 'Gibraltar',
        'flag': '185-gibraltar.png',
        'dialCode': '+350'
    },
    'GR': {
        'name_en': 'Greece',
        'name_fr': 'Grèce',
        'name_es': 'Grecia',
        'flag': '071-greece.png',
        'dialCode': '+30'
    },
    'GL': {
        'name_en': 'Greenland',
        'name_fr': 'Groenland',
        'name_es': 'Groenlandia',
        'flag': '183-greenland.png',
        'dialCode': '+299'
    },
    'GD': {
        'name_en': 'Grenada',
        'name_fr': 'Grenade',
        'name_es': 'Granada',
        'flag': '182-grenada.png',
        'dialCode': '+1'
    },
    'GU': {
        'name_en': 'Guam',
        'name_fr': 'Guam',
        'name_es': 'Guam',
        'flag': '181-guam.png',
        'dialCode': '+1'
    },
    'GT': {
        'name_en': 'Guatemala',
        'name_fr': 'Guatémala',
        'name_es': 'Guatemala',
        'flag': '040-guatemala.png',
        'dialCode': '+502'
    },
    'GG': {
        'name_en': 'Guernsey',
        'name_fr': 'Guernesey',
        'name_es': 'Bailía de Guernsey',
        'flag': '180-guernsey.png',
        'dialCode': '+44'
    },
    'GN': {
        'name_en': 'Guinea',
        'name_fr': 'Guinée',
        'name_es': 'Guinea',
        'flag': '154-guinea.png',
        'dialCode': '+224'
    },
    'GW': {
        'name_en': 'Guinea-Bissau',
        'name_fr': 'Guinea-Bissau',
        'name_es': 'Guinea-Bisáu',
        'flag': '209-guinea-bissau.png',
        'dialCode': '+245'
    },
    'HT': {
        'name_en': 'Haiti',
        'name_fr': 'Haïti',
        'name_es': 'Haití',
        'flag': '247-haiti.png',
        'dialCode': '+509'
    },
    'HN': {
        'name_en': 'Honduras',
        'name_fr': 'Honduras',
        'name_es': 'Honduras',
        'flag': '027-honduras.png',
        'dialCode': '+504'
    },
    'HK': {
        'name_en': 'Hong Kong',
        'name_fr': 'Hong Kong',
        'name_es': 'Hong Kong',
        'flag': '067-hong-kong.png',
        'dialCode': '+852'
    },
    'HU': {
        'name_en': 'Hungary',
        'name_fr': 'Hongrie',
        'name_es': 'Hungría',
        'flag': '053-hungary.png',
        'dialCode': '+36'
    },
    'IS': {
        'name_en': 'Iceland',
        'name_fr': 'Islande',
        'name_es': 'Islandia',
        'flag': '041-iceland.png',
        'dialCode': '+354'
    },
    'IN': {
        'name_en': 'India',
        'name_fr': 'Inde',
        'name_es': 'India',
        'flag': '217-india.png',
        'dialCode': '+91'
    },
    'ID': {
        'name_en': 'Indonesia',
        'name_fr': 'Indonésie',
        'name_es': 'Indonesia',
        'flag': '078-indonesia.png',
        'dialCode': '+62'
    },
    'IR': {
        'name_en': 'Iran',
        'name_fr': 'Iran',
        'name_es': 'Irán',
        'flag': '063-iran.png',
        'dialCode': '+98'
    },
    'IQ': {
        'name_en': 'Iraq',
        'name_fr': 'Irak',
        'name_es': 'Irak',
        'flag': '007-iraq.png',
        'dialCode': '+964'
    },
    'IE': {
        'name_en': 'Ireland',
        'name_fr': 'Irlande',
        'name_es': 'Irlanda',
        'flag': '070-ireland.png',
        'dialCode': '+353'
    },
    'IM': {
        'name_en': 'Isle of Man',
        'name_fr': 'Île de Man',
        'name_es': 'Isla de Man',
        'flag': '246-isle-of-man.png',
        'dialCode': '+44'
    },
    'IL': {
        'name_en': 'Israel',
        'name_fr': 'Israël',
        'name_es': 'Israel',
        'flag': '060-israel.png',
        'dialCode': '+972'
    },
    'IT': {
        'name_en': 'Italy',
        'name_fr': 'Italie',
        'name_es': 'Italia',
        'flag': '011-italy.png',
        'dialCode': '+39'
    },
    'JM': {
        'name_en': 'Jamaica',
        'name_fr': 'Jamaïque',
        'name_es': 'Jamaica',
        'flag': '026-jamaica.png',
        'dialCode': '+1'
    },
    'JP': {
        'name_en': 'Japan',
        'name_fr': 'Japon',
        'name_es': 'Japón',
        'flag': '033-japan.png',
        'dialCode': '+81'
    },
    'JE': {
        'name_en': 'Jersey',
        'name_fr': 'Jersey',
        'name_es': 'Jersey',
        'flag': '254-jersey.png',
        'dialCode': '+44'
    },
    'JO': {
        'name_en': 'Jordan',
        'name_fr': 'Jordanie',
        'name_es': 'Jordania',
        'flag': '042-jordan.png',
        'dialCode': '+962'
    },
    'KZ': {
        'name_en': 'Kazakhstan',
        'name_fr': 'Kazakhstan',
        'name_es': 'Kazajistán',
        'flag': '034-kazakhstan.png',
        'dialCode': '+7'
    },
    'KE': {
        'name_en': 'Kenya',
        'name_fr': 'Kenya',
        'name_es': 'Kenia',
        'flag': '029-kenya.png',
        'dialCode': '+254'
    },
    'KI': {
        'name_en': 'Kiribati',
        'name_fr': 'Kiribati',
        'name_es': 'Kiribati',
        'flag': '179-kiribati.png',
        'dialCode': '+686'
    },
    'KO': {
        'name_en': 'North Korea',
        'name_fr': 'Corée du Nord',
        'name_es': 'Corea del Norte',
        'flag': '037-north-korea.png',
        'dialCode': '+850'
    },
    'KR': {
        'name_en': 'South Korea',
        'name_fr': 'Corée du Sud',
        'name_es': 'Corea del Sur',
        'flag': '055-south-korea.png',
        'dialCode': '+82'
    },
    'KW': {
        'name_en': 'Kuwait',
        'name_fr': 'Koweït',
        'name_es': 'Kuwait',
        'flag': '178-kuwait.png',
        'dialCode': '+965'
    },
    'KG': {
        'name_en': 'Kyrgyzstan',
        'name_fr': 'Kirghizistan',
        'name_es': 'Kirguistán',
        'flag': '208-kyrgyzstan.png',
        'dialCode': '+996'
    },
    'LA': {
        'name_en': 'Laos',
        'name_fr': 'Laos',
        'name_es': 'Laos',
        'flag': '069-laos.png',
        'dialCode': '+856'
    },
    'LV': {
        'name_en': 'Latvia',
        'name_fr': 'Lettonie',
        'name_es': 'Letonia',
        'flag': '032-latvia.png',
        'dialCode': '+371'
    },
    'LB': {
        'name_en': 'Lebanon',
        'name_fr': 'Liban',
        'name_es': 'Líbano',
        'flag': '008-lebanon.png',
        'dialCode': '+961'
    },
    'LS': {
        'name_en': 'Lesotho',
        'name_fr': 'Lesotho',
        'name_es': 'Lesoto',
        'flag': '244-lesotho.png',
        'dialCode': '+266'
    },
    'LR': {
        'name_en': 'Liberia',
        'name_fr': 'Liberia',
        'name_es': 'Liberia',
        'flag': '218-liberia.png',
        'dialCode': '+231'
    },
    'LY': {
        'name_en': 'Libya',
        'name_fr': 'Libie',
        'name_es': 'Libia',
        'flag': '225-libya.png',
        'dialCode': '+218'
    },
    'LI': {
        'name_en': 'Liechtenstein',
        'name_fr': 'Liechtenstein',
        'name_es': 'Liechtenstein',
        'flag': '216-liechtenstein.png',
        'dialCode': '+423'
    },
    'LT': {
        'name_en': 'Lithuania',
        'name_fr': 'Lithuanie',
        'name_es': 'Lituania',
        'flag': '025-lithuania.png',
        'dialCode': '+370'
    },
    'LU': {
        'name_en': 'Luxembourg',
        'name_fr': 'Luxembourg',
        'name_es': 'Luxemburgo',
        'flag': '023-luxembourg.png',
        'dialCode': '+352'
    },
    'MO': {
        'name_en': 'Macao',
        'name_fr': 'Macao',
        'name_es': 'Macao',
        'flag': '144-macao.png',
        'dialCode': '+853'
    },
    'MK': {
        'name_en': 'Macedonia',
        'name_fr': 'Macédoine',
        'name_es': 'Macedonia',
        'flag': '223-republic-of-macedonia.png',
        'dialCode': '+389'
    },
    'MG': {
        'name_en': 'Madagascar',
        'name_fr': 'Madagascar',
        'name_es': '',
        'flag': '253-madagascar.png',
        'dialCode': '+261'
    },
    'MW': {
        'name_en': 'Malawi',
        'name_fr': 'Malawi',
        'name_es': 'Malaui',
        'flag': '252-malawi.png',
        'dialCode': '+265'
    },
    'MY': {
        'name_en': 'Malaysia',
        'name_fr': 'Malaisie',
        'name_es': 'Malasia',
        'flag': '056-malaysia.png',
        'dialCode': '+60'
    },
    'MV': {
        'name_en': 'Maldives',
        'name_fr': 'Maldives',
        'name_es': 'Maldivas',
        'flag': '232-maldives.png',
        'dialCode': '+960'
    },
    'ML': {
        'name_en': 'Mali',
        'name_fr': 'Mali',
        'name_es': 'Malí',
        'flag': '207-mali.png',
        'dialCode': '+223'
    },
    'MT': {
        'name_en': 'Malta',
        'name_fr': 'Malte',
        'name_es': 'Malta',
        'flag': '012-malta.png',
        'dialCode': '+356'
    },
    'MH': {
        'name_en': 'Marshall Islands',
        'name_fr': 'Îles Marshall',
        'name_es': 'Islas Marshall',
        'flag': '205-marshall-island.png',
        'dialCode': '+692'
    },
    'MQ': {
        'name_en': 'Martinique',
        'name_fr': 'Martinique',
        'name_es': 'Martinica',
        'flag': '137-martinique.png',
        'dialCode': '+596'
    },
    'MR': {
        'name_en': 'Mauritania',
        'name_fr': 'Mauritanie',
        'name_es': 'Mauritania',
        'flag': '177-mauritania.png',
        'dialCode': '+222'
    },
    'MU': {
        'name_en': 'Mauritius',
        'name_fr': 'Île Maurice',
        'name_es': 'Mauricio',
        'flag': '021-mauritius.png',
        'dialCode': '+230'
    },
    'MX': {
        'name_en': 'Mexico',
        'name_fr': 'Méxique',
        'name_es': 'México',
        'flag': '239-mexico.png',
        'dialCode': '+52'
    },
    'FM': {
        'name_en': 'Micronesia',
        'name_fr': 'Micronésie',
        'name_es': 'Micronesia',
        'flag': '204-micronesia.png',
        'dialCode': '+691'
    },
    'MD': {
        'name_en': 'Moldova',
        'name_fr': 'Moldavie',
        'name_es': 'Moldavia',
        'flag': '231-moldova.png',
        'dialCode': '+373'
    },
    'MC': {
        'name_en': 'Monaco',
        'name_fr': 'Monaco',
        'name_es': 'Mónaco',
        'flag': '043-monaco.png',
        'dialCode': '+377'
    },
    'MN': {
        'name_en': 'Mongolia',
        'name_fr': 'Mongolie',
        'name_es': 'Mongolia',
        'flag': '251-mongolia.png',
        'dialCode': '+976'
    },
    'ME': {
        'name_en': 'Montenegro',
        'name_fr': 'Montenegro',
        'name_es': 'Montenegro',
        'flag': '230-montenegro.png',
        'dialCode': '+382'
    },
    'MS': {
        'name_en': 'Montserrat',
        'name_fr': 'Montserrat',
        'name_es': 'Montserrat',
        'flag': '175-montserrat.png',
        'dialCode': '+1'
    },
    'MA': {
        'name_en': 'Morocco',
        'name_fr': 'Maroc',
        'name_es': 'Marruecos',
        'flag': '086-morocco.png',
        'dialCode': '+212'
    },
    'MZ': {
        'name_en': 'Mozambique',
        'name_fr': 'Mozambique',
        'name_es': 'Mozambique',
        'flag': '006-mozambique.png',
        'dialCode': '+258'
    },
    'MM': {
        'name_en': 'Myanmar',
        'name_fr': 'Myanmar',
        'name_es': 'Birmania',
        'flag': '028-myanmar.png',
        'dialCode': '+95'
    },
    'NA': {
        'name_en': 'Namibia',
        'name_fr': 'Namibie',
        'name_es': 'Namibia',
        'flag': '020-namibia.png',
        'dialCode': '+264'
    },
    'NR': {
        'name_en': 'Nauru',
        'name_fr': 'Nauru',
        'name_es': 'Naurú',
        'flag': '173-nauru.png',
        'dialCode': '+674'
    },
    'NP': {
        'name_en': 'Nepal',
        'name_fr': 'Népal',
        'name_es': 'Nepal',
        'flag': '249-nepal.png',
        'dialCode': '+977'
    },
    'NL': {
        'name_en': 'Netherlands',
        'name_fr': 'Pays Bas',
        'name_es': 'Países Bajos',
        'flag': '195-netherlands.png',
        'dialCode': '+31'
    },
    'NZ': {
        'name_en': 'New Zealand',
        'name_fr': 'Nouvelle Zélande',
        'name_es': 'Nueva Zelanda',
        'flag': '048-new-zealand.png',
        'dialCode': '+64'
    },
    'NI': {
        'name_en': 'Nicaragua',
        'name_fr': 'Nicaragua',
        'name_es': 'Nicaragua',
        'flag': '014-nicaragua.png',
        'dialCode': '+505'
    },
    'NE': {
        'name_en': 'Niger',
        'name_fr': 'Niger',
        'name_es': 'Níger',
        'flag': '203-niger.png',
        'dialCode': '+227'
    },
    'NG': {
        'name_en': 'Nigeria',
        'name_fr': 'Nigeria',
        'name_es': 'Nigeria',
        'flag': '010-nigeria.png',
        'dialCode': '+234'
    },
    'NU': {
        'name_en': 'Niue',
        'name_fr': 'Niue',
        'name_es': 'Niue',
        'flag': '143-niue.png',
        'dialCode': '+683'
    },
    'NF': {
        'name_en': 'Norfolk Island',
        'name_fr': 'Île Norfolk',
        'name_es': 'Isla Norfolk',
        'flag': '202-norfolk-island.png',
        'dialCode': '+672 3'
    },
    'MP': {
        'name_en': 'Northern Mariana Islands',
        'name_fr': 'Îles Mariannes du Nord',
        'name_es': 'Islas Marianas del Norte',
        'flag': '172-northern-marianas-islands.png',
        'dialCode': '+1'
    },
    'NO': {
        'name_en': 'Norway',
        'name_fr': 'Norvège',
        'name_es': 'Noruega',
        'flag': '058-norway.png',
        'dialCode': '+47'
    },
    'OM': {
        'name_en': 'Oman',
        'name_fr': 'Oman',
        'name_es': 'Omán',
        'flag': '002-oman.png',
        'dialCode': '+968'
    },
    'PK': {
        'name_en': 'Pakistan',
        'name_fr': 'Pakistan',
        'name_es': 'Pakistán',
        'flag': '031-pakistan.png',
        'dialCode': '+92'
    },
    'PW': {
        'name_en': 'Palau',
        'name_fr': 'Palaos',
        'name_es': 'Palaos',
        'flag': '142-palau.png',
        'dialCode': '+680'
    },
    'PS': {
        'name_en': 'Palestine',
        'name_fr': 'Palestine',
        'name_es': 'Palestina',
        'flag': '170-palestine.png',
        'dialCode': '+970'
    },
    'PA': {
        'name_en': 'Panama',
        'name_fr': 'Panama',
        'name_es': 'Panamá',
        'flag': '047-panama.png',
        'dialCode': '+507'
    },
    'PG': {
        'name_en': 'Papua New Guinea',
        'name_fr': 'Papouasie-Nouvelle-Guinée',
        'name_es': 'Papúa Nueva Guinea',
        'flag': '229-papua-new-guinea.png',
        'dialCode': '+675'
    },
    'PE': {
        'name_en': 'Peru',
        'name_fr': 'Péru',
        'name_es': 'Perú',
        'flag': '074-peru.png',
        'dialCode': '+51'
    },
    'PH': {
        'name_en': 'Philippines',
        'name_fr': 'Philippines',
        'name_es': 'Filipinas',
        'flag': '076-philippines.png',
        'dialCode': '+63'
    },
    'PN': {
        'name_en': 'Pitcairn',
        'name_fr': 'Pitcairn',
        'name_es': 'Islas Pitcairn',
        'flag': '169-pitcairn-islands.png',
        'dialCode': '+64'
    },
    'PL': {
        'name_en': 'Poland',
        'name_fr': 'Polande',
        'name_es': 'Polonia',
        'flag': '108-poland.png',
        'dialCode': '+48'
    },
    'PT': {
        'name_en': 'Portugal',
        'name_fr': 'Portugal',
        'name_es': 'Portugal',
        'flag': '174-portugal.png',
        'dialCode': '+351'
    },
    'PR': {
        'name_en': 'Puerto Rico',
        'name_fr': 'Puerto Rico',
        'name_es': 'Puerto Rico',
        'flag': '005-puerto-rico.png',
        'dialCode': '+1'
    },
    'QA': {
        'name_en': 'Qatar',
        'name_fr': 'Qatar',
        'name_es': 'Catar',
        'flag': '019-qatar.png',
        'dialCode': '+974'
    },
    'RO': {
        'name_en': 'Romania',
        'name_fr': 'Romanie',
        'name_es': 'Rumania',
        'flag': '050-romania.png',
        'dialCode': '+40'
    },
    'RU': {
        'name_en': 'Russia',
        'name_fr': 'Russie',
        'name_es': 'Rusia',
        'flag': '228-russia.png',
        'dialCode': '+7'
    },
    'RW': {
        'name_en': 'Rwanda',
        'name_fr': 'Rwanda',
        'name_es': 'Ruanda',
        'flag': '243-rwanda.png',
        'dialCode': '+250'
    },
    'LC': {
        'name_en': 'Saint-Lucia',
        'name_fr': 'Sainte-Lucie',
        'name_es': 'Santa Lucía',
        'flag': '139-st-lucia.png',
        'dialCode': '+1'
    },
    'WS': {
        'name_en': 'Samoa',
        'name_fr': 'Samoa',
        'name_es': 'Samoa',
        'flag': '248-samoa.png',
        'dialCode': '+685'
    },
    'SM': {
        'name_en': 'San Marino',
        'name_fr': 'Saint-Marin',
        'name_es': 'San Marino',
        'flag': '214-san-marino.png',
        'dialCode': '+378'
    },
    'ST': {
        'name_en': 'Sao Tome and Principe',
        'name_fr': 'Sao Tomé-et-Principe',
        'name_es': 'Santo Tomé y Príncipe',
        'flag': '201-sao-tome-and-principe.png',
        'dialCode': '+239'
    },
    'SA': {
        'name_en': 'Saudi Arabia',
        'name_fr': 'Arabie Saoudite',
        'name_es': 'Arabia Saudita',
        'flag': '059-saudi-arabia.png',
        'dialCode': '+966'
    },
    'SN': {
        'name_en': 'Senegal',
        'name_fr': 'Sénégal',
        'name_es': 'Senegal',
        'flag': '259-senegal.png',
        'dialCode': '+221'
    },
    'RS': {
        'name_en': 'Serbia',
        'name_fr': 'Serbie',
        'name_es': 'Serbia',
        'flag': '035-serbia.png',
        'dialCode': '+381'
    },
    'SC': {
        'name_en': 'Seychelles',
        'name_fr': 'Seychelles',
        'name_es': 'Seychelles',
        'flag': '150-seychelles.png',
        'dialCode': '+248'
    },
    'SL': {
        'name_en': 'Sierra Leone',
        'name_fr': 'Sierra Leone',
        'name_es': 'Sierra Leona',
        'flag': '149-sierra-leone.png',
        'dialCode': '+232'
    },
    'SG': {
        'name_en': 'Singapore',
        'name_fr': 'Singapour',
        'name_es': 'Singapur',
        'flag': '141-singapore.png',
        'dialCode': '+65'
    },
    'SX': {
        'name_en': 'Sint Maarten',
        'name_fr': 'Saint-Martin',
        'name_es': 'San Martin',
        'flag': '165-sint-maarten.png',
        'dialCode': '+1'
    },
    'SK': {
        'name_en': 'Slovakia',
        'name_fr': 'Slovakie',
        'name_es': 'Eslovaquia',
        'flag': '045-slovakia.png',
        'dialCode': '+421'
    },
    'SB': {
        'name_en': 'Solomon Islands',
        'name_fr': 'Îles Salomon',
        'name_es': 'Islas Salomón',
        'flag': '163-solomon-islands.png',
        'dialCode': '+677'
    },
    'SO': {
        'name_en': 'Somalia',
        'name_fr': 'Somalie',
        'name_es': 'Somalia',
        'flag': '198-somalia.png',
        'dialCode': '+252'
    },
    'SS': {
        'name_en': 'South Sudan',
        'name_fr': 'Soudan du Sud',
        'name_es': 'Sudán del Sur',
        'flag': '161-south-sudan.png',
        'dialCode': '+211'
    },
    'ES': {
        'name_en': 'Spain',
        'name_fr': 'Espagne',
        'name_es': 'España',
        'flag': '044-spain.png',
        'dialCode': '+34'
    },
    'ZA': {
        'name_en': 'South Africa',
        'name_fr': 'Afrique du Sud',
        'name_es': 'Sudáfrica',
        'flag': '075-south-africa.png',
        'dialCode': '+27'
    },
    'LK': {
        'name_en': 'Sri Lanka',
        'name_fr': 'Sri Lanka',
        'name_es': 'Sri Lanka',
        'flag': '238-sri-lanka.png',
        'dialCode': '+94'
    },
    'SD': {
        'name_en': 'Sudan',
        'name_fr': 'Soudan',
        'name_es': 'Sudán',
        'flag': '221-sudan.png',
        'dialCode': '+249'
    },
    'SR': {
        'name_en': 'Suriname',
        'name_fr': 'Suriname',
        'name_es': 'Surinam',
        'flag': '197-suriname.png',
        'dialCode': '+597'
    },
    'SE': {
        'name_en': 'Sweden',
        'name_fr': 'Suède',
        'name_es': 'Suecia',
        'flag': '073-sweden.png',
        'dialCode': '+46'
    },
    'CH': {
        'name_en': 'Switzerland',
        'name_fr': 'Suisse',
        'name_es': 'Suiza',
        'flag': '097-switzerland.png',
        'dialCode': '+41'
    },
    'SY': {
        'name_en': 'Syria',
        'name_fr': 'Syrie',
        'name_es': 'Siria',
        'flag': '039-syria.png',
        'dialCode': '+963'
    },
    'TW': {
        'name_en': 'Taiwan',
        'name_fr': 'Taïwan',
        'name_es': 'Taiwán',
        'flag': '080-taiwan.png',
        'dialCode': '+886'
    },
    'TJ': {
        'name_en': 'Tajikistan',
        'name_fr': 'Tajikistan',
        'name_es': 'Tayikistán',
        'flag': '236-tajikistan.png',
        'dialCode': '+992'
    },
    'TZ': {
        'name_en': 'Tanzania',
        'name_fr': 'Tanzanie',
        'name_es': 'Tanzania',
        'flag': '003-tanzania.png',
        'dialCode': '+255'
    },
    'TH': {
        'name_en': 'Thailand',
        'name_fr': 'Thailand',
        'name_es': 'Tailandia',
        'flag': '184-thailand.png',
        'dialCode': '+66'
    },
    'TG': {
        'name_en': 'Togo',
        'name_fr': 'Togo',
        'name_es': 'Togo',
        'flag': '193-togo.png',
        'dialCode': '+228'
    },
    'TK': {
        'name_en': 'Tokelau',
        'name_fr': 'Tokélaou',
        'name_es': 'Tokelau',
        'flag': '158-tokelau.png',
        'dialCode': '+690'
    },
    'TO': {
        'name_en': 'Tonga',
        'name_fr': 'Tonga',
        'name_es': 'Tonga',
        'flag': '138-tonga.png',
        'dialCode': '+676'
    },
    'TT': {
        'name_en': 'Trinidad and Tobago',
        'name_fr': 'Trinité-et-Tobago',
        'name_es': 'Trinidad y Tobago',
        'flag': '235-trinidad-and-tobago.png',
        'dialCode': '+1'
    },
    'TN': {
        'name_en': 'Tunisia',
        'name_fr': 'Tunisie',
        'name_es': 'Túnez',
        'flag': '013-tunisia.png',
        'dialCode': '+216'
    },
    'TR': {
        'name_en': 'Turkey',
        'name_fr': 'Turquie',
        'name_es': 'Turquía',
        'flag': '119-turkey.png',
        'dialCode': '+90'
    },
    'TM': {
        'name_en': 'Turkmenistan',
        'name_fr': 'Turkménistan',
        'name_es': 'Turkmenistán',
        'flag': '192-turkmenistan.png',
        'dialCode': '+993'
    },
    'TC': {
        'name_en': 'Turks and Caicos Islands',
        'name_fr': 'Îles Turques-et-Caïques',
        'name_es': 'Islas Turcas y Caicos',
        'flag': '156-turks-and-caicos.png',
        'dialCode': '+1'
    },
    'UG': {
        'name_en': 'Uganda',
        'name_fr': 'Ouganda',
        'name_es': 'Uganda',
        'flag': '009-uganda.png',
        'dialCode': '+256'
    },
    'UA': {
        'name_en': 'Ukraine',
        'name_fr': 'Ukraine',
        'name_es': 'Ucrania',
        'flag': '065-ukraine.png',
        'dialCode': '+380'
    },
    'AE': {
        'name_en': 'United Arab Emirates',
        'name_fr': 'Émirats arabes unis',
        'name_es': 'Emiratos Árabes Unidos',
        'flag': '068-united-arab-emirates.png',
        'dialCode': '+971'
    },
    'GB': {
        'name_en': 'United Kingdom',
        'name_fr': 'Angleterre',
        'name_es': 'Reino Unido',
        'flag': '262-united-kingdom.png',
        'dialCode': '+44'
    },
    'US': {
        'name_en': 'United States',
        'name_fr': 'États-Unis',
        'name_es': 'Estados Unidos',
        'flag': '153-united-states-of-america.png',
        'dialCode': '+1'
    },
    'UY': {
        'name_en': 'Uruguay',
        'name_fr': 'Uruguay',
        'name_es': 'Uruguay',
        'flag': '038-uruguay.png',
        'dialCode': '+598'
    },
    'UZ': {
        'name_en': 'Uzbekistan',
        'name_fr': 'Uzbekistan',
        'name_es': 'Uzbekistán',
        'flag': '220-uzbekistn.png',
        'dialCode': '+998'
    },
    'VU': {
        'name_en': 'Vanuatu',
        'name_fr': 'Vanuatu',
        'name_es': 'Vanuatu',
        'flag': '148-vanuatu.png',
        'dialCode': '+678'
    },
    'VE': {
        'name_en': 'Venezuela',
        'name_fr': 'Venezuela',
        'name_es': 'Venezuela',
        'flag': '057-venezuela.png',
        'dialCode': '+58'
    },
    'VN': {
        'name_en': 'Vietnam',
        'name_fr': 'Viêtnam',
        'name_es': 'Vietnam',
        'flag': '164-vietnam.png',
        'dialCode': '+84'
    },
    'VG': {
        'name_en': 'Virgin Islands',
        'name_fr': 'Îles Vierges britanniques',
        'name_es': 'Islas Vírgenes Británicas',
        'flag': '188-virgin-islands.png',
        'dialCode': '+1'
    },
    'YE': {
        'name_en': 'Yemen',
        'name_fr': 'Yémen',
        'name_es': 'Yemén',
        'flag': '219-yemen.png',
        'dialCode': '+967'
    },
    'ZM': {
        'name_en': 'Zambia',
        'name_fr': 'Zambie',
        'name_es': 'Zambia',
        'flag': '016-zambia.png',
        'dialCode': '+260'
    },
    'ZW': {
        'name_en': 'Zimbabwe',
        'name_fr': 'Zimbabwe',
        'name_es': 'Zimbabue',
        'flag': '242-zimbabwe.png',
        'dialCode': '+263'
    }
};

/**
 * Get country information for a given country code.
 *
 * @param countryCode: ISO 3166-1 Alpha-2 code
 *
 * @returns {Object}
 */
const getCountryInfo = (countryCode) => {
    if (countryCode) {
        countryCode = countryCode.toUpperCase();
    }

    if (countryCode in countries) {
        return countries[countryCode];
    } else {
        return {
            'name_en': 'Unknown',
            'name_fr': 'Inconnu',
            'name_es': 'Desconocido',
            'flag': '000-unknown.png',
            'dialCode': '+'
        };
    }
}

/**
 * Convert Countries Object to Array
 * Sort Countries by their names [ascending]
 *
 * @returns {array}
 */
const getSortedCountries = () => {

    let name = 'name_en';

    switch ( urlParams.get( 'l' ) ) {
        case 'fr':
            name = 'name_fr';
            break;
        case 'es':
            name = 'name_es';
            break;
        default:
            name = 'name_en';
    }

    let countriesList = []; 
    
    Object.keys(countries).forEach( function(key, index) {

        let countryInfo;
        countryInfo = {
            'code': key,
            'name': countries[key][name],
            'flag': countries[key].flag,
            'dialCode': countries[key].dialCode
        };

        countriesList.push( countryInfo );
    });

    countriesList.sort(function(a, b) {
        let aName = a.name.toUpperCase();
        let bName = b.name.toUpperCase();
        return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
    });

    return countriesList;

}

export { getCountryInfo, getSortedCountries };